export const UPDATE_TOKON = 'UPDATE_TOKON' // tokon的更新
export const UPDATE_AUTHORIZD = 'UPDATE_AUTHORIZD' // 更新登录标识
export const INIT_USER_INFO = 'INIT_USER_INFO' // 初始化用户信息